import React from 'react';

const NoResultsFound = () => {
  const { phone, phoneVisual, phoneAccessible } = window.drupalSettings.storeDetails ?? {};

  if (!phone || !phoneVisual || !phoneAccessible) {
    return (
      <p className="cmp-tire-finder-shell__error-message">
        Sorry, we didn&apos;t find any results. Please modify your search and try again.
      </p>
    );
  }

  return (
    <p className="cmp-tire-finder-shell__error-message">
      <span>
        Sorry, we didn&apos;t find any results. Please modify your search, or call
        {' '}
        <a href={`tel:${phone}`} className="cmp-link" aria-label={phoneAccessible}>
          {phoneVisual}
        </a>
        {' '}
        for assistance.
      </span>
    </p>
  );
};

export { NoResultsFound };
